import { setWindowLocation } from '@eventbrite/http';
import { Dispatch } from 'redux';
import { formatUrl } from 'url-lib';
import { getCheckoutWidgetLanguageUrl } from '../api/constants';
import {
    getAffiliateCode,
    getIsModal,
    getWaitlistCode,
    getWidgetParentUrl,
    isAndroidApp,
    isIosApp,
} from '../selectors/app';
import { saveSession } from '../session';
import { CheckoutState } from '../state';
import { trackLanguageChange } from './eventAnalytics';

export const CHANGE_LANGUAGE = 'changeLanguage';

const getProfile = ({
    useIosProfile,
    useAndroidProfile,
}: {
    useIosProfile?: boolean;
    useAndroidProfile?: boolean;
}) => {
    if (useIosProfile) {
        return 'mobile_ios';
    }

    return useAndroidProfile ? 'mobile_android' : null;
};

export const createUrlWithLanguage = ({
    locale,
    widgetParentUrl,
    isModal,
    affiliateCode,
    waitlistCode,
    useIosProfile,
    useAndroidProfile,
}: {
    locale: string;
    widgetParentUrl?: string | null;
    isModal?: boolean;
    affiliateCode?: string;
    waitlistCode?: string;
    useIosProfile?: boolean;
    useAndroidProfile?: boolean;
}) => {
    const url = getCheckoutWidgetLanguageUrl(locale);
    const params = {
        parent: widgetParentUrl,
        modal: isModal || null,
        aff: affiliateCode,
        w: waitlistCode,
        profile: getProfile({ useIosProfile, useAndroidProfile }),
    };

    return url ? formatUrl(url, params) : null;
};

export const changeLanguage =
    (locale: string, checkoutStep: string) =>
    (dispatch: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();

        const affiliateCode = getAffiliateCode(state);
        const isModal = getIsModal(state);
        const useAndroidProfile = isAndroidApp(state);
        const useIosProfile = isIosApp(state);
        const waitlistCode = getWaitlistCode(state);
        const widgetParentUrl = getWidgetParentUrl(state);

        dispatch(trackLanguageChange(locale, checkoutStep));

        saveSession(state);

        // Allow all the instructions above to finish running before reload
        setTimeout(() => {
            const urlWithSelectedLanguage = createUrlWithLanguage({
                locale,
                widgetParentUrl,
                isModal,
                affiliateCode,
                waitlistCode,
                useIosProfile,
                useAndroidProfile,
            });

            // Reload the page with the selected language
            setWindowLocation(urlWithSelectedLanguage);
        }, 300);
    };
